import { STUDENT_CATEGOREIS } from "./handbook";

export const levelLists = [
  { id: "Internship", name: "Internship" },
  { id: "Fresher", name: "Fresher" },
  { id: "Junior", name: "Junior" },
  { id: "Senior", name: "Senior" },
  { id: "Manager", name: "Manager" },
];
export const industryLists = [
  { id: "all", name: "Tất cả" },
  { id: "An toàn lao động", name: "An toàn lao động" },
  { id: "Bán hàng kỹ thuật", name: "Bán hàng kỹ thuật" },
  { id: "Bán lẻ / Bán sỉ", name: "Bán lẻ / Bán sỉ" },
  { id: "Báo chí/ Truyền hình", name: "Báo chí/ Truyền hình" },
  { id: "Bảo hiểm", name: "Bảo hiểm" },
  { id: "Bảo trì/ Sửa chữa", name: "Bảo trì/ Sửa chữa" },
  { id: "Bất động sản", name: "Bất động sản" },
  { id: "Biên/ Phiên dịch", name: "Biên/ Phiên dịch" },
  { id: "Bưu chính - Viễn thông", name: "Bưu chính - Viễn thông" },
  {
    id: "Chứng khoán/ Vàng/ Ngoại tệ",
    name: "Chứng khoán/ Vàng/ Ngoại tệ",
  },
  {
    id: "Cơ khí/ Chế tạo/ Tự động hóa",
    name: "Cơ khí/ Chế tạo/ Tự động hóa",
  },
  { id: "Công nghệ cao", name: "Công nghệ cao" },
  { id: "Công nghệ Ô tô", name: "Công nghệ Ô tô" },
  { id: "Công nghệ thông tin", name: "Công nghệ thông tin" },
  { id: "Dầu khí/ Hóa chất", name: "Dầu khí/ Hóa chất" },
  { id: "Dệt may/ Da giày", name: "Dệt may/ Da giày" },
  { id: "Địa chất/ Khoán sản", name: "Địa chất/ Khoán sản" },
  { id: "Dịch vụ khách hàng", name: "Dịch vụ khách hàng" },
  { id: "Điện/ Điện tử/ Điện lạnh", name: "Điện/ Điện tử/ Điện lạnh" },
  { id: "Điện từ viễn thông", name: "Điện từ viễn thông" },
  { id: "Du lịch", name: "Du lịch" },
  {
    id: "Dược phẩm/ Công nghệ sinh học",
    name: "Dược phẩm/ Công nghệ sinh học",
  },
  { id: "Giáo dục/ Đào tạo", name: "Giáo dục/ Đào tạo" },
  { id: "Hàng cao cấp", name: "Hàng cao cấp" },
  { id: "Hàng gia dụng", name: "Hàng gia dụng" },
  { id: "Hàng hải", name: "Hàng hải" },
  { id: "Hàng không", name: "Hàng không" },
  { id: "Hàng tiêu dùng", name: "Hàng tiêu dùng" },
  { id: "Hành chính/ Văn phòng", name: "Hành chính/ Văn phòng" },
  { id: "Hóa học/ Sinh học", name: "Hóa học/ Sinh học" },
  { id: "Hoạch định/ Dự án", name: "Hoạch định/ Dự án" },
  { id: "In ấn/ Xuất bản", name: "In ấn/ Xuất bản" },
  { id: "IT phần cứng/ Mạng", name: "IT phần cứng/ Mạng" },
  { id: "IT phần mềm", name: "IT phần mềm" },
  { id: "Kế toán/ Kiểm toán", name: "Kế toán/ Kiểm toán" },
  { id: "Khách sạn/ Nhà hàng", name: "Khách sạn/ Nhà hàng" },
  { id: "Kiến trúc", name: "Kiến trúc" },
  { id: "Kinh doanh/ Bán hàng", name: "Kinh doanh/ Bán hàng" },
  { id: "Logistics", name: "Logistics" },
  { id: "Luật/ Pháp lý", name: "Luật/ Pháp lý" },
  {
    id: "Marketing/ Truyền thông/ Quảng cáo",
    name: "Marketing/ Truyền thông/ Quảng cáo",
  },
  {
    id: "Môi trường/ Xử lý chất thải",
    name: "Môi trường/ Xử lý chất thải",
  },
  { id: "Mỹ phẩm/ Trang sức", name: "Mỹ phẩm/ Trang sức" },
  {
    id: "Mỹ thuật/ Nghệ thuật/ Điện ảnh",
    name: "Mỹ thuật/ Nghệ thuật/ Điện ảnh",
  },
  { id: "Ngân hàng/ Tài chính", name: "Ngân hàng/ Tài chính" },
  {
    id: "NGO/ Phi chính phủ/ Phi lợi nhuận",
    name: "NGO/ Phi chính phủ/ Phi lợi nhuận",
  },
  { id: "Nhân sự", name: "Nhân sự" },
  { id: "Nông/ Lâm/ Ngư nghiệp", name: "Nông/ Lâm/ Ngư nghiệp" },
  {
    id: "Quản lý chất lượng (QA/ QC)",
    name: "Quản lý chất lượng (QA/ QC)",
  },
  { id: "Quản lý điều hành", name: "Quản lý điều hành" },
  { id: "Sản phẩm công nghiệp", name: "Sản phẩm công nghiệp" },
  { id: "Sản xuất", name: "Sản xuất" },
  { id: "Spa/ Làm đẹp", name: "Spa/ Làm đẹp" },
  { id: "Tài chính/ Đầu tư", name: "Tài chính/ Đầu tư" },
  { id: "Thiết kế đồ họa", name: "Thiết kế đồ họa" },
  { id: "Thiết kế nội thất", name: "Thiết kế nội thất" },
  { id: "Thời trang", name: "Thời trang" },
  { id: "Thư ký/ Trợ lý", name: "Thư ký/ Trợ lý" },
  { id: "Thực phẩm/ Đồ uống", name: "Thực phẩm/ Đồ uống" },
  { id: "Tổ chức sự kiện/ Quà tặng", name: "Tổ chức sự kiện/ Quà tặng" },
  { id: "Tư vấn", name: "Tư vấn" },
  { id: "Vận tải/ Kho vận", name: "Vận tải/ Kho vận" },
  { id: "Xây dựng", name: "Xây dựng" },
  { id: "Xuất nhập khẩu", name: "Xuất nhập khẩu" },
  { id: "Y tế/ Dược", name: "Y tế/ Dược" },
  { id: "Lĩnh vực khác", name: "Lĩnh vực khác" },
];
export const careerLists = [
  { id: "Công nghệ thông tin", name: "Công nghệ thông tin" },
  { id: "Hành chính nhân sự", name: "Hành chính nhân sự" },
  { id: "Sale", name: "Sale" },
  { id: "Marketing", name: "Marketing" },
  { id: "Báo chí, truyền hình", name: "Báo chí, truyền hình" },
  { id: "Kế toán, kiểm toán", name: "Kế toán, kiểm toán" },
  { id: "Thiết kế", name: "Thiết kế" },
  { id: "Dữ liệu", name: "Dữ liệu" },
  { id: "Tài chính, ngân hàng", name: "Tài chính, ngân hàng" },
  { id: "Logistics - xuất nhập khẩu", name: "Logistics - xuất nhập khẩu" },
  { id: "Khác", name: "Khác" },
];

export const documentTypeLists = [
  { id: "Sách", name: "Sách" },
  { id: "Ebook", name: "Ebook" },
  { id: "Podcast", name: "Podcast" },
];

export const radioReviewSchoolList = [
  {
    name: "Tìm trọ, review nhà trọ.",
    id: "Tìm trọ, review nhà trọ.",
  },
  {
    name: "Review KTX",
    id: "Review KTX",
  },
  {
    name: "Review điểm ăn uống gần trường",
    id: "Review điểm ăn uống gần trường",
  },
  {
    name: "Review cách học tập trên đại học",
    id: "Review cách học tập trên đại học",
  },
  {
    name: "Đi làm năm nhất",
    id: "Đi làm năm nhất",
  },
  {
    name: "Tips sinh tồn trên ĐH",
    id: "Tips sinh tồn trên ĐH",
  },
  {
    name: "Câu lạc bộ",
    id: "Câu lạc bộ",
  },
  {
    name: "Khác",
    id: "Khác",
  },
];

export const radioDocumentStudyList = [
  {
    name: "Tài liệu đại cương",
    id: "Tài liệu đại cương",
  },
  {
    name: "Tài liệu chuyên ngành",
    id: "Tài liệu chuyên ngành",
  },

  {
    name: "Khác",
    id: "Khác",
  },
];

export const radioNotiExamList = [
  {
    name: "Thông tin tuyển sinh",
    id: "Thông tin tuyển sinh",
  },
  {
    name: "Đào tạo",
    id: "Đào tạo",
  },
  {
    name: "Hợp tác quốc tế",
    id: "Hợp tác quốc tế",
  },
  {
    name: "Nghiên cứu khoa học",
    id: "Nghiên cứu khoa học",
  },
  {
    name: "Đảng - Đoàn thể",
    id: "Đảng - Đoàn thể",
  },
  {
    name: "Khác",
    id: "Khác",
  },
];

export const radioNotiOutputList = [
  {
    name: "Chuẩn đầu ra tiếng Anh",
    id: "Chuẩn đầu ra tiếng Anh",
  },
  {
    name: "Chuẩn đầu ra tiếng Trung",
    id: "Chuẩn đầu ra tiếng Trung",
  },
  {
    name: "Chuẩn đầu ra Tin học",
    id: "Chuẩn đầu ra Tin học",
  },
  {
    name: "Chuẩn đầu ra GDQP",
    id: "Chuẩn đầu ra GDQP",
  },
  {
    name: "Khác",
    id: "Khác",
  },
];

export const clubTypeLists = [
  { id: "CLB Tình nguyện", name: "CLB Tình nguyện" },
  { id: "CLB Học thuật", name: "CLB Học thuật" },
  { id: "CLB Sở thích", name: "CLB Sở thích" },
  { id: "Thuộc Liên chi Đoàn", name: "Thuộc Liên chi Đoàn" },
  { id: "Thuộc Liên chi Hội", name: "Thuộc Liên chi Hội" },
];
export const clubTagLists = [
  { id: "Kinh doanh", name: "Kinh doanh" },
  { id: "Kinh tế", name: "Kinh tế" },
  { id: "Khởi nghiệp", name: "Khởi nghiệp" },
  { id: "Đầu tư", name: "Đầu tư" },
  { id: "Tình nguyện", name: "Tình nguyện" },
  { id: "Âm nhạc", name: "Âm nhạc" },
  { id: "Học thuật", name: "Học thuật" },
  { id: "Môi trường", name: "Môi trường" },
  { id: "Tiếng Anh", name: "Tiếng Anh" },
  { id: "Nghiên cứu khoa học", name: "Nghiên cứu khoa học" },
  { id: "Du lịch", name: "Du lịch" },
  { id: "Sách", name: "Sách" },
  { id: "Ngôn ngữ", name: "Ngôn ngữ" },
  { id: "Nhân sự", name: "Nhân sự" },
  { id: "Tin học văn phòng", name: "Tin học văn phòng" },
  { id: "Thể thao điện tử", name: "Thể thao điện tử" },
  { id: "Thuyết trình", name: "Thuyết trình" },
  { id: "MC", name: "MC" },
  { id: "Lễ tân", name: "Lễ tân" },
  { id: "Văn nghệ", name: "Văn nghệ" },
  { id: "Thời trang", name: "Thời trang" },
  { id: "Marketing", name: "Marketing" },
  { id: "Phản biện", name: "Phản biện" },
  { id: "Logistics", name: "Logistics" },
  { id: "Báo chí", name: "Báo chí" },
  { id: "Chứng khoán", name: "Chứng khoán" },
  { id: "Công nghệ thông tin", name: "Công nghệ thông tin" },
  { id: "Khách sạn", name: "Khách sạn" },
  { id: "Kế toán", name: "Kế toán" },
  { id: "Tài chính", name: "Tài chính" },
  { id: "Võ thuật", name: "Võ thuật" },
  { id: "Ngân hàng", name: "Ngân hàng" },
  { id: "Luật", name: "Luật" },
  { id: "Điện ảnh", name: "Điện ảnh" },
  { id: "Kỹ năng sống", name: "Kỹ năng sống" },
  { id: "Thương mại điện tử", name: "Thương mại điện tử" },
  { id: "Du học", name: "Du học" },
  { id: "Nghệ thuật", name: "Nghệ thuật" },
  { id: "Ngoại giao", name: "Ngoại giao" },
  { id: "Thể thao", name: "Thể thao" },
  { id: "Phát tiển bản thân", name: "Phát tiển bản thân" },
  { id: "Khác", name: "Khác" },
];
export const clubRangeLists = [
  { id: "all", name: "Tất cả" },
  { id: "Trực thuộc NEU", name: "Trực thuộc NEU" },
  { id: "Trực thuộc FTU", name: "Trực thuộc FTU" },
  { id: "Trực thuộc AOF", name: "Trực thuộc AOF" },
  { id: "Trực thuộc BA", name: "Trực thuộc BA" },
  { id: "Trực thuộc VNU", name: "Trực thuộc VNU" },
  { id: "Trực thuộc TMU", name: "Trực thuộc TMU" },
  { id: "Trực thuộc PTIT", name: "Trực thuộc PTIT" },
  { id: "Trực thuộc HUST", name: "Trực thuộc HUST" },
  { id: "Trực thuộc Phenikaa", name: "Trực thuộc Phenikaa" },
  { id: "Trực thuộc TLU", name: "Trực thuộc TLU" },
  { id: "Trực thuộc UEH", name: "Trực thuộc UEH" },
  { id: "Trực thuộc NTTU", name: "Trực thuộc NTTU" },
  { id: "Trực thuộc VHU", name: "Trực thuộc VHU" },
  { id: "Trực thuộc HCMUT", name: "Trực thuộc HCMUT" },
  { id: "Trực thuộc UFM", name: "Trực thuộc UFM" },
  { id: "Trực thuộc HUB", name: "Trực thuộc HUB" },
  { id: "Trực thuộc TDTU", name: "Trực thuộc TDTU" },
  { id: "Trực thuộc UTC", name: "Trực thuộc UTC" },
  { id: "Trực thuộc HNUE", name: "Trực thuộc HNUE" },
  { id: "Trực thuộc AJC", name: "Trực thuộc AJC" },
  { id: "Trực thuộc HLU", name: "Trực thuộc HLU" },
  { id: "Trực thuộc UTT", name: "Trực thuộc UTT" },
  { id: "Khác", name: "Khác" },
];

export const projectRangeLists = [
  { id: "Học tập và nghiên cứu", name: "Học tập và nghiên cứu" },
  { id: "Giáo dục", name: "Giáo dục" },
  { id: "Kinh doanh và quản lý", name: "Kinh doanh và quản lý" },
  { id: "Xã hội và tình nguyện", name: "Xã hội và tình nguyện" },
  { id: "Lập trình và công nghệ", name: "Lập trình và công nghệ" },
  { id: "Thiết kế và nghệ thuật", name: "Thiết kế và nghệ thuật" },
];

export const projectTypeLists = [
  { id: "Online", name: "Online" },
  { id: "Offline", name: "Offline" },
  { id: "Khác", name: "Khác" },
];

export const projectWorkingTypeLists = [
  { id: "Fulltime", name: "Fulltime" },
  { id: "Partime", name: "Partime" },
];

export const projectLocationLists = [
  { id: "Hà Nội", name: "Hà Nội" },
  { id: "Hồ Chí Minh", name: "Hồ Chí Minh" },
  { id: "Nước ngoài", name: "Nước ngoài" },
  { id: "Toàn quốc", name: "Toàn quốc" },
  { id: "Khác", name: "Khác" },
];

export const projectOranizationLists = [
  { id: "Công ty nước ngoài", name: "Công ty nước ngoài" },
  { id: "Công ty Việt Nam", name: "Công ty Việt Nam" },
  {
    id: "Cơ quan Nhà nước; NGO/NPO/CLB Tình nguyện",
    name: "Cơ quan Nhà nước; NGO/NPO/CLB Tình nguyện",
  },
  { id: "Khởi nghiệp - Startup", name: "Khởi nghiệp - Startup" },
  { id: "Khác", name: "Khác" },
];

export const competitionRangeLists = [
  { id: "Công nghệ thông tin", name: "Công nghệ thông tin" },
  { id: "Hành chính nhân sự", name: "Hành chính nhân sự" },
  { id: "Sale", name: "Sale" },
  { id: "Marketing", name: "Marketing" },
  { id: "Kế toán, kiểm toán", name: "Kế toán, kiểm toán" },
  { id: "Thiết kế", name: "Thiết kế" },
  { id: "Dữ liệu", name: "Dữ liệu" },
  { id: "Tài chính, ngân hàng", name: "Tài chính, ngân hàng" },
  { id: "Logistic - xuất nhập khẩu", name: "Logistic - xuất nhập khẩu" },
  { id: "Khác", name: "Khác" },
];
export const competitionTypeLists = [
  { id: "Giải Casestudy", name: "Giải Casestudy" },
  { id: "Trắc nghiệm", name: "Trắc nghiệm" },
  { id: "Pitching", name: "Pitching" },
];

export const languageList = [
  { name: "Tiếng việt", id: "Tiếng việt" },
  { name: "Tiếng anh", id: "Tiếng anh" },
];

export const costLists = [
  { id: "0", name: "Miễn phí" },
  { id: "<300", name: "<300k" },
  { id: "300 - 600", name: "300 - 600k" },
  { id: "600 - 1000", name: "600 - 1000k" },
  { id: ">1000", name: ">1000k" },
];

export const detailLevelList = [
  { name: 1, id: "1" },
  { name: 2, id: "2" },
  { name: 3, id: "3" },
  { name: 4, id: "4" },
  { name: 5, id: "5" },
];
export const resultList = [
  { name: "Nhóm tính cách của bạn", id: "Nhóm tính cách của bạn" },
  {
    name: "Điểm mạnh, điểm yếu của nhóm tính cách",
    id: "Điểm mạnh, điểm yếu của nhóm tính cách",
  },
  {
    name: "Mối quan hệ về tình bạn, tình yêu, gia đình",
    id: "Mối quan hệ về tình bạn, tình yêu, gia đình",
  },
  {
    name: "Nghề nghiệp phù hợp với nhóm tính cách",
    id: "Nghề nghiệp phù hợp với nhóm tính cách",
  },
  {
    name: "Người, nhân vật nổi tiếng có nhóm tính cách",
    id: "Người, nhân vật nổi tiếng có nhóm tính cách",
  },
  {
    name: "10 chỉ số thông minh của bạn",
    id: "10 chỉ số thông minh của bạn",
  },
];
export const toolList = [
  { name: "MBTI", id: "MBTI" },
  { name: "DISC", id: "DISC" },
  { name: "Thần số học", id: "Thần số học" },
  { name: "Sinh trắc vân tay", id: "Sinh trắc vân tay" },
  { name: "MI", id: "MI" },
];

export const radioCategoriesList = [
  { id: STUDENT_CATEGOREIS.REVIEW_SCHOOL, data: radioReviewSchoolList },
  { id: STUDENT_CATEGOREIS.DOCUMENT, data: radioDocumentStudyList },
  { id: STUDENT_CATEGOREIS.OUTPUT_STANDARDS_NEWS, data: radioNotiOutputList },
  { id: STUDENT_CATEGOREIS.ADMISSION_NEWS, data: radioNotiExamList },
];

export const schoolarshipType = [
  { id: "Toàn phần", name: "Toàn phần" },
  { id: "Bán phần", name: "Bán phần" },
  { id: "Học bổng chính phủ", name: "Học bổng chính phủ" },
  { id: "Học bổng doanh nghiệp", name: "Học bổng doanh nghiệp" },
  { id: "Học bổng trao đổi", name: "Học bổng trao đổi" },
];

export const schoolarshipEducationLevel = [
  { id: "Đại học", name: "Đại học" },
  { id: "Thạc sĩ", name: "Thạc sĩ" },
  { id: "Tiến sĩ", name: "Tiến sĩ" },
];

export const schoolarshipMajor = [
  { id: "Kế toán", name: "Kế toán" },
  { id: "Khối kinh tế", name: "Khối kinh tế" },
  { id: "Tài chính", name: "Tài chính" },
  { id: "Quản lý thông tin", name: "Quản lý thông tin" },
  { id: "Kinh doanh quốc tế", name: "Kinh doanh quốc tế" },
  { id: "Thương mại quốc tế", name: "Thương mại quốc tế" },
  { id: "Quản lý", name: "Quản lý" },
  { id: "Quảng cáo, tiếp thị", name: "Quảng cáo, tiếp thị" },
  {
    id: "Quản lý chuỗi cung ứng, vận tải",
    name: "Quản lý chuỗi cung ứng, vận tải",
  },
  { id: "Thuế", name: "Thuế" },
  { id: "Quản lý nhân sự", name: "Quản lý nhân sự" },
  { id: "Tâm lý học", name: "Tâm lý học" },
];

export const schoolarshipCountry = [
  { id: "Châu Á", name: "Châu Á" },
  { id: "Châu Âu", name: "Châu Âu" },
  { id: "Châu Mỹ", name: "Châu Mỹ" },
];

export const schoolarshipTime = [
  { id: "1 năm", name: "1 năm" },
  { id: "2 năm", name: "2 năm" },
  { id: "3 năm", name: "3 năm" },
  { id: "4 năm", name: "4 năm" },
  { id: "Hơn 4 năm", name: "Hơn 4 năm" },
];

export const statusConstant = [
  {
    label: "Hoạt động",
    value: "active",
    name: "status",
  },
  {
    label: "Không hoạt động",
    value: "inactive",
    name: "status",
  },
];

export const priorityConstant = [
  {
    label: "Ưu tiên",
    value: 1,
    name: "priority",
  },
  {
    label: "Không ưu tiên",
    value: 0,
    name: "priority",
  },
];

export const softSkillLists = [
  { id: "Tin học văn phòng", name: "Tin học văn phòng" },
  { id: "Giao tiếp", name: "Giao tiếp" },
  { id: "Nâng cao hiệu suất", name: "Nâng cao hiệu suất" },
  { id: "Giải quyết vấn đề", name: "Giải quyết vấn đề" },
  { id: "Tư duy công việc", name: "Tư duy công việc" },
  { id: "Quản lý cảm xúc", name: "Quản lý cảm xúc" },
  { id: "Quản lý thời gian", name: "Quản lý thời gian" },
  { id: "Đàm phán, thương lượng", name: "Đàm phán, thương lượng" },
];

export const industryAdvanceLists = [
  { id: "An toàn lao động", name: "An toàn lao động" },
  { id: "Bán hàng kỹ thuật", name: "Bán hàng kỹ thuật" },
  { id: "Bán lẻ / Bán sỉ", name: "Bán lẻ / Bán sỉ" },
  { id: "Báo chí/ Truyền hình", name: "Báo chí/ Truyền hình" },
  { id: "Bảo hiểm", name: "Bảo hiểm" },
  { id: "Bảo trì/ Sửa chữa", name: "Bảo trì/ Sửa chữa" },
  { id: "Bất động sản", name: "Bất động sản" },
  { id: "Biên/ Phiên dịch", name: "Biên/ Phiên dịch" },
  { id: "Bưu chính - Viễn thông", name: "Bưu chính - Viễn thông" },
  {
    id: "Chứng khoán/ Vàng/ Ngoại tệ",
    name: "Chứng khoán/ Vàng/ Ngoại tệ",
  },
  {
    id: "Cơ khí/ Chế tạo/ Tự động hóa",
    name: "Cơ khí/ Chế tạo/ Tự động hóa",
  },
  { id: "Công nghệ cao", name: "Công nghệ cao" },
  { id: "Công nghệ Ô tô", name: "Công nghệ Ô tô" },
  { id: "Công nghệ thông tin", name: "Công nghệ thông tin" },
  { id: "Dầu khí/ Hóa chất", name: "Dầu khí/ Hóa chất" },
  { id: "Dệt may/ Da giày", name: "Dệt may/ Da giày" },
  { id: "Địa chất/ Khoán sản", name: "Địa chất/ Khoán sản" },
  { id: "Dịch vụ khách hàng", name: "Dịch vụ khách hàng" },
  { id: "Điện/ Điện tử/ Điện lạnh", name: "Điện/ Điện tử/ Điện lạnh" },
  { id: "Điện từ viễn thông", name: "Điện từ viễn thông" },
  { id: "Du lịch", name: "Du lịch" },
  {
    id: "Dược phẩm/ Công nghệ sinh học",
    name: "Dược phẩm/ Công nghệ sinh học",
  },
  { id: "Giáo dục/ Đào tạo", name: "Giáo dục/ Đào tạo" },
  { id: "Hàng cao cấp", name: "Hàng cao cấp" },
  { id: "Hàng gia dụng", name: "Hàng gia dụng" },
  { id: "Hàng hải", name: "Hàng hải" },
  { id: "Hàng không", name: "Hàng không" },
  { id: "Hàng tiêu dùng", name: "Hàng tiêu dùng" },
  { id: "Hành chính/ Văn phòng", name: "Hành chính/ Văn phòng" },
  { id: "Hóa học/ Sinh học", name: "Hóa học/ Sinh học" },
  { id: "Hoạch định/ Dự án", name: "Hoạch định/ Dự án" },
  { id: "In ấn/ Xuất bản", name: "In ấn/ Xuất bản" },
  { id: "IT phần cứng/ Mạng", name: "IT phần cứng/ Mạng" },
  { id: "IT phần mềm", name: "IT phần mềm" },
  { id: "Kế toán/ Kiểm toán", name: "Kế toán/ Kiểm toán" },
  { id: "Khách sạn/ Nhà hàng", name: "Khách sạn/ Nhà hàng" },
  { id: "Kiến trúc", name: "Kiến trúc" },
  { id: "Kinh doanh/ Bán hàng", name: "Kinh doanh/ Bán hàng" },
  { id: "Logistics", name: "Logistics" },
  { id: "Luật/ Pháp lý", name: "Luật/ Pháp lý" },
  {
    id: "Marketing/ Truyền thông/ Quảng cáo",
    name: "Marketing/ Truyền thông/ Quảng cáo",
  },
  {
    id: "Môi trường/ Xử lý chất thải",
    name: "Môi trường/ Xử lý chất thải",
  },
  { id: "Mỹ phẩm/ Trang sức", name: "Mỹ phẩm/ Trang sức" },
  {
    id: "Mỹ thuật/ Nghệ thuật/ Điện ảnh",
    name: "Mỹ thuật/ Nghệ thuật/ Điện ảnh",
  },
  { id: "Ngân hàng/ Tài chính", name: "Ngân hàng/ Tài chính" },
  {
    id: "NGO/ Phi chính phủ/ Phi lợi nhuận",
    name: "NGO/ Phi chính phủ/ Phi lợi nhuận",
  },
  { id: "Nhân sự", name: "Nhân sự" },
  { id: "Nông/ Lâm/ Ngư nghiệp", name: "Nông/ Lâm/ Ngư nghiệp" },
  {
    id: "Quản lý chất lượng (QA/ QC)",
    name: "Quản lý chất lượng (QA/ QC)",
  },
  { id: "Quản lý điều hành", name: "Quản lý điều hành" },
  { id: "Sản phẩm công nghiệp", name: "Sản phẩm công nghiệp" },
  { id: "Sản xuất", name: "Sản xuất" },
  { id: "Spa/ Làm đẹp", name: "Spa/ Làm đẹp" },
  { id: "Tài chính/ Đầu tư", name: "Tài chính/ Đầu tư" },
  { id: "Thiết kế đồ họa", name: "Thiết kế đồ họa" },
  { id: "Thiết kế nội thất", name: "Thiết kế nội thất" },
  { id: "Thời trang", name: "Thời trang" },
  { id: "Thư ký/ Trợ lý", name: "Thư ký/ Trợ lý" },
  { id: "Thực phẩm/ Đồ uống", name: "Thực phẩm/ Đồ uống" },
  { id: "Tổ chức sự kiện/ Quà tặng", name: "Tổ chức sự kiện/ Quà tặng" },
  { id: "Tư vấn", name: "Tư vấn" },
  { id: "Vận tải/ Kho vận", name: "Vận tải/ Kho vận" },
  { id: "Xây dựng", name: "Xây dựng" },
  { id: "Xuất nhập khẩu", name: "Xuất nhập khẩu" },
  { id: "Y tế/ Dược", name: "Y tế/ Dược" },
  { id: "Lĩnh vực khác", name: "Lĩnh vực khác" },
];

export const ratingByStudentLists = [
  { id: 3.5, name: "3.5+/5" },
  { id: 4, name: "4+/5" },
  { id: 4.5, name: "4.5+/5" },
  { id: 5, name: "5/5" },
];
